var _path, _tspan, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "81mm",
    height: "81.445mm",
    viewBox: "0 0 81 81.445",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(86.156 -99.099)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 .99454 -.0014131 .54291)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0703 0 0 1.1017 -158.73 -32.108)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m79.229 192.25s-10.502-17.421-1.3407-35.379c5.9111-11.587 8.4059-16.376 3.6842-21.154 0 0 10.724 10.019 12.408 25.491 1.6849 15.472-1.2022-10.925 4.8842-18.497 5.5008-6.8433 6.4445-12.022 5.1929-20.057-0.47035-3.0193 1.313 1.853 1.313 1.853s12.279 5.9631 9.6814 24.668c-1.4772 10.638 2.4825 11.174 2.4825 11.174l4.0782-11.485-1.4082-16.982c0.49689 5.9919 9.5833 10.394 12.24 18.562 3.4994 10.757 0.16119 13.73 0.16119 13.73l-0.45899 3.8367",
    fill: "none",
    stroke: "#3f004f",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("text", {
    x: 109.52168,
    y: 188.89644,
    fill: "#68002d",
    fontFamily: "'BPG Courier S GPL&GNU'",
    fontSize: "25.302px",
    stroke: "#68002d",
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 109.52168,
    y: 188.89644,
    fill: "#68002d",
    stroke: "#68002d"
  }, "In")))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -85.656,
    y: 99.599,
    width: 80,
    height: 80,
    fill: "none",
    stroke: "#3f004f",
    strokeLinejoin: "bevel"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.15fdfdc5942911ce376ffc141ea6d6fa.svg";
export { ForwardRef as ReactComponent };